export default {
  header: 'Definicje parametrów aktywów',
  subheader: 'Ta strona umożliwia zarządzanie niestandardowymi parametrami zasobów, które mogą być ponownie wykorzystane w kreatorze sygnałów.',
  empty: 'Nie zdefiniowano żadnych parametrów zasobów zdefiniowanych przez użytkownika.',
  confirmDelete: {
    header: 'Usunąć parametr "{parameter}"?',
    message: 'Ta definicja może być używana przez kilka zasobów. Tej operacji nie można cofnąć.',
  },
};
